<template>
  <div class="map" ref="mapPanelTop">
    <div v-show="!showBusLocation && !showSearchPanelFrom && !showSearchPanelTo &&!showGenreList &&!showGenreListTo">
      <div v-if="isOpenSearchPanel" class="w-full z-20 absolute">
        <div class="p-2 bg-brand_sub" @click="closeSearchPanel">
          <div class="float-left"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"/></svg></div>
          <div>出発地・目的地の指定を隠す</div>
        </div>
      </div>
      <div v-else class="w-full z-20 absolute">
        <div class="p-2 bg-brand_sub" @click="openSearchPanel">
          <div class="float-left"><img src="@/assets/images/search.svg" height="20px" viewBox="0 0 20 20" width="20px" class="text-link"></div>
          <div>経路を検索する</div>
        </div>
      </div>
    </div>
    <transition tag="form" appear>
      <div v-show="isOpenSearchPanel && !showBusLocation &&!showGenreList" class="bg-brand_sub w-full z-10 pt-6" :class="showMapPanel ? 'absolute h-48' : 'fixed'">
        <div>
          <div class="px-2 font-bold" v-show="showFilterMenu">
            <div class="float-left pt-6 font-bold absolute">出発地</div>
            <div class="float-left mt-16 pt-2 font-bold absolute">目的地</div>
            <div class="float-left mt-12 pl-3 font-bold absolute z-40" @click="swapPlace">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/></svg>
            </div>
            <div class="float-left mt-6 right-4 font-bold absolute z-40" @click="clearFrom">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
            </div>
            <div class="float-left mt-16 pt-2 right-4 font-bold absolute z-40" @click="clearTo">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
            </div>
          </div>
          <div
            v-show="showMapPanel || showSearchPanelFrom"
            class="z-30 w-full"
            :class="showMapPanel ? 'absolute pl-14' : 'sticky'">
            <search-form
              @search="onSearch"
              @incrementSearch="onIncrementSearch"
              @closeSearchPanel="onCloseSearchPanel"
              @clearForm="clearFrom"
              @openGenreList="onOpenGenreList"
              :onSearch="showSearchPanelFrom"
              :value="from.name !== undefined ? from.name : ''"
              :showLabelFrom="showSearchPanelFrom"
            />
          </div>
          <div
            v-show="showFilterMenu || showSearchPanelTo"
            class="z-20 w-full"
            :class="showMapPanel ? 'mt-12 absolute pl-14' : 'sticky'">
            <search-form
              @search="onSearchTo"
              @incrementSearch="onIncrementSearchTo"
              @closeSearchPanel="onCloseSearchPanel"
              @clearForm="clearTo"
              @openGenreList="onOpenGenreListTo"
              :onSearch="showSearchPanelTo"
              :value="to.name !== undefined ? to.name : ''"
              :showLabelTo="showSearchPanelTo"
            />
          </div>
          <div v-show="showFilterMenu" class="z-10 w-full mt-24 absolute">
            <div class="pt-6 px-2">
              <a class="button-primary py-2 block" @click="searchCourse">
                ルートを検索する
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="!isOpenSearchPanel && showBusLocation" class="w-full z-10 absolute">
      <div class="p-2 font-bold bg-brand_sub" @click="closeBusLocation">
        <div class="float-left"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg></div>
        <div>マップに戻る</div>
      </div>
    </div>
    <div v-show="showFilterMenu && !showBusLocation" class="z-10 w-full absolute" :class="isOpenSearchPanel ? 'mt-48' : 'mt-10'">
      <filter-menu />
    </div>
    <div v-show="showMapPanel" class="h-full w-full">
      <map-panel
        ref="mapPanel"
        @search="onSearch"
        @closeSearchPanel="onCloseSearchPanel"
        :zoomLevel="zoomLevel"
      />
    </div>
    <div v-if="showGenreList" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenre"
      />
    </div>
    <div v-if="showGenreListTo" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenreTo"
      />
    </div>
    <div v-show="showSearchPanelFrom" class="h-full w-full pb-4 pt-36">
      <search-panel
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearFrom"
        :searchWord="searchWordFrom"
        searchType="departure"
        @selectGenre="onSelectGenre"
        :genre="genre"
        :isStationOnly="false"
      />
    </div>
    <div v-show="showSearchPanelTo" class="h-full w-full pb-4 pt-36">
      <search-panel
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearTo"
        :searchWord="searchWordTo"
        searchType="arrival"
        @selectGenre="onSelectGenre"
        :genre="genre"
        :isStationOnly="false"
      />
    </div>
    <div v-show="showBusLocation" class="h-full w-full">
      <bus-location />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import SearchForm from '../components/organisms/Map/SearchForm'
import SearchPanel from '../components/organisms/Map/SearchPanel'
import MapPanel from '../components/organisms/Map/MapPanel'
import BusLocation from '../components/molecules/BusLocation.vue'
import FilterMenu from '../components/organisms/Map/FilterMenu'
import Constants from '../constants'
import GenreList from '../components/organisms/Map/GenreList'
import { event } from 'vue-gtag'

export default {
  beforeRouteEnter (route, redirect, next) {
    const p = {
      name: redirect.name,
      params: redirect.params,
      route: route.params.route
    }
    next((vm) => {
      vm.$store.dispatch('map/updateFrom', p)
      if (p.route) {
        const fromLocation = p.route.points[0].location
        const center = {
          lat: fromLocation.latitude,
          lng: fromLocation.longitude
        }
        vm.$store.dispatch('map/updateCenter', center)
      }
    })
  },
  created () {
    if (this.$route.params.latLng) {
      // 指定された緯度経度を中心
      this.$store.dispatch('map/setOffset', true)
      this.$store.dispatch('map/updateCenterLatLng', this.$route.params.latLng)
    } else {
      if (navigator.geolocation) {
        this.$store.dispatch('geolocation/fetchLocation')
          .then(() => {
            const location = this.$store.getters['geolocation/getLocation']
            const distance = this.getDistance(location.lat,location.lng,Constants.DEFAULT_STATION_LOCATION.latitude,Constants.DEFAULT_STATION_LOCATION.longitude)
            this.locationMonitor()
            if (distance <= Constants.DEFAULT_MY_LOCATION_RADIUS) {
              this.$store.dispatch('map/setOffset', true)
              this.$store.dispatch('map/updateCenter', location)
            }
          })
      }
    }
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('drawer/close')
    this.$store.dispatch('busLocation/close')
    this.$store.dispatch('genres/fetchAll')
      .then(() => {
        this.$store.dispatch('loading/endLoading')
        this.$store.dispatch('places/fetchAll')
          .then(() => {
            this.$refs.mapPanel.mapInitialized()
            const poiId = this.$route.params.poiId
            if (poiId !== undefined) {
              const place = this.$store.getters['places/getPlace'](poiId)
              if (place) {
                event("POI詳細表示", {
                  poi_id: place.id,
                  poi_name: place.name
                });
                this.$store.dispatch('drawer/openPlace', { place: place, full: true })
              } else {
                this.$store.dispatch('drawer/updateSelectedPlace', {})
              }
            }
            // バスロケ取得(バスロケがリリース時に対応しないためコメントアウト)
            // this.$store.dispatch('busLocation/fetchAll')
            //   .then(() => {
            //     // ジャンル指定
            //     if (this.$route.params.tagId !== undefined) {
            //       this.$store.dispatch('user/offFilterAll')
            //       const genre = this.$store.getters['genres/getGenreFromId'](this.$route.params.tagId)
            //       this.$store.dispatch('user/onFilter', genre)
            //       this.isOpenSearchPanel = false
            //     }
            //   })
          })
      })
      this.$store.dispatch('drawer/showButton')
  },
  components: {
    SearchForm,
    SearchPanel,
    MapPanel,
    BusLocation,
    FilterMenu,
    GenreList,
  },
  data () {
    return {
      showMapPanel: true,
      showSearchPanelFrom: false,
      showSearchPanelTo: false,
      showBusLocation: false,
      searchWordFrom: '',
      searchWordTo: '',
      mobakuMessage: false,
      zoomLevel: 15,
      showFilterMenu: true,
      isOpenSearchPanel: false,
      from: "",
      to: "",
      showGenreList: false,
      showGenreListTo:false,
      genre: {},
    }
  },
  methods: {
    onSearch: function () {
      this.showSearchPanelFrom = true
      this.showSearchPanelTo = false
      this.showPlaceList = false
      this.showMapPanel = false
      this.showFilterMenu = false
      this.showGenreList = false
      this.showGenreListTo = false
    },
    onSearchTo: function () {
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = true
      this.showPlaceList = false
      this.showMapPanel = false
      this.showFilterMenu = false
      this.showGenreList = false
      this.showGenreListTo = false
    },
    onCloseSearchPanel: function () {
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = false
      this.showMapPanel = true
      this.genre = {}
      this.showFilterMenu = true
      this.showGenreList = false
      this.showGenreListTo = false
    },
    onOpenGenreList: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = true
      this.showGenreListTo = false
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = false
    },
    onOpenGenreListTo: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = false
      this.showGenreListTo = true
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = false
    },
    onCloseGenreList: function () {
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = false
      this.showMapPanel = true
      this.showFilterMenu = true
      this.showGenreList = false
      this.showGenreListTo = false
    },
    onIncrementSearch: function (word) {
      this.searchWordFrom = word
    },
    onIncrementSearchTo: function (word) {
      this.searchWordTo = word
    },
    onSelectGenre: function (genre) {
      this.genre = genre
      this.showGenreList = false
      this.showSearchPanelFrom = true
      this.$refs['mapPanelTop'].scrollIntoView({ behavior: 'smooth'})
    },
    onSelectGenreTo: function (genre) {
      this.genre = genre
      this.showGenreListTo = false
      this.showSearchPanelTo = true
      this.$refs['mapPanelTop'].scrollIntoView({ behavior: 'smooth'})
    },
    searchCourse: function () {
      const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      var url = Constants.REAL_TIME_SEARCH_WEB_LIST[env_key] + "?utm_source=chofu&utm_medium=referral&utm_campaign=chofu"
      if (this.from.location !== undefined) {
        url += "&frompoi=" + encodeURIComponent(this.from.name)
        if (this.from.stationCode !== undefined) {
          url += "&fromcode=" + this.from.stationCode
        } else {
          url += "&fromlatitude=" + this.from.location.latitude + "&fromlongitude=" + this.from.location.longitude
        }
      }
      if (this.to.location !== undefined) {
        url += "&topoi=" + encodeURIComponent(this.to.name)
        if (this.to.stationCode !== undefined) {
          url += "&tocode=" + this.to.stationCode
        } else {
          url += "&tolatitude=" + this.to.location.latitude + "&tolongitude=" + this.to.location.longitude
        }
      }
      if (this.token !== null) {
        url += "&token=" + this.token
      }
      if (this.from.location === undefined) {
        if (this.to.location === undefined) {
          event('ルートを検索',{from:"現在地",to:"現在地",route:"現在地:現在地"})                    
        } else {
          event('ルートを検索',{from:"現在地",to:this.to.name,route:"現在地:"+this.to.name})          
        }
      } else if (this.to.location === undefined) {
        event('ルートを検索',{from:this.from.name,to:"現在地",route:this.from.name+":現在地"})          
      } else {
        event('ルートを検索',{from:this.from.name,to:this.to.name,route:this.from.name+":"+this.to.name})
      }
      window.open(url)
    },
    openSearchPanel: function () {
      this.isOpenSearchPanel = true
      this.$store.dispatch('busLocation/close')
    },
    closeSearchPanel: function () {
      this.isOpenSearchPanel = false
    },
    initMap: function () {
      this.map.addListener("drag", () => {
        this.isOpenSearchPanel = false
      })
    },
    swapPlace: function () {
      const from = this.$store.getters['map/getSearchFrom']
      const to = this.$store.getters['map/getSearchTo']
      this.$store.dispatch('map/setSearchFrom', to)
      this.$store.dispatch('map/setSearchTo', from)
    },
    clearFrom: function () {
      this.$store.dispatch('map/clearSearchFrom')
    },
    clearTo: function () {
      this.$store.dispatch('map/clearSearchTo')
    },
    closeBusLocation: function () {
      this.$store.dispatch('busLocation/close')
    },
    beforeEnter: function(el) {
      el.style.height = '0'
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave: function(el) {
      el.style.height = '0'
    },
    setMapCenter (location) {
      if (!_.isEmpty(this.map)) {
        this.map.panTo(location)
        const isMapOffset = this.$store.getters['map/getOffset']
        if (isMapOffset) {
          this.$store.dispatch('map/setOffset', false)
          this.setMapOffset()
        }
      } else {
        setTimeout(() => {
          this.setMapCenter(location)
        }, 100)
      }
    },
    setMapOffset () {
      // オフセットを取得
      if (this.isFull) {
        const drawerTop = 384
        const filterMenuBottom = 40
        this.map.panBy(0, Math.round((window.innerHeight + filterMenuBottom / 2 + drawerTop / 2) / 2 - window.innerHeight / 2))
      } else {
        const drawerTop = this.isOpen ? 128 : 0
        const filterMenu = document.querySelector(".filterMenu")
        const filterMenuBottom = filterMenu.getBoundingClientRect().bottom
        this.map.panBy(0, Math.round((window.innerHeight - filterMenuBottom - drawerTop) / 2 - window.innerHeight / 2))
      }
    },
    locationMonitor () {
      setTimeout(() => {
        this.$store.dispatch('geolocation/fetchLocation')
          .then(() => {
            this.locationMonitor()
          })
      }, 5000)
    },
    getDistance (lat1, lng1, lat2, lng2) {
      lat1 *= Math.PI / 180;
      lng1 *= Math.PI / 180;
      lat2 *= Math.PI / 180;
      lng2 *= Math.PI / 180;
      const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
      return d;
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      isOpen: 'drawer/getIsOpen',
      isFull: 'drawer/getIsFull',
      token: 'user/getToken',
      selectedBusStops: 'busLocation/getSelectedStops',
      searchFrom: 'map/getSearchFrom',
      searchTo: 'map/getSearchTo',
      busLocationIsOpen: 'busLocation/getIsOpen',
      map: 'googleMap/getMap'
    })
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) {
        this.showSearchPanelFrom = false
        this.showSearchPanelTo = false
        this.showMapPanel = true
        this.showBusLocation = false
        this.showFilterMenu = true
      }
    },
    showPlaceFull: function (val) {
      if (val && this.isOpenSearchPanel) {
        this.isOpenSearchPanel = false
      }
    },
    selectedBusStops: function (val) {
      if (!_.isEmpty(val)) {
        this.showMapPanel = true
        this.isOpenSearchPanel = false
      }
    },
    searchFrom: function (val) {
      this.from = val
      this.isOpenSearchPanel = true
    },
    searchTo: function (val) {
      this.to = val
      this.isOpenSearchPanel = true
    },
    busLocationIsOpen: function (val) {
      this.showBusLocation = val
    },
    map: function () {
      // this.initMap()
    },
    center: function (val) {
      this.setMapCenter(val)
    }
  }
}
</script>
